import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static targets = []

  connect() {
    new TomSelect(this.element, {
      render: {
        no_results: function(data, escape) {
          return `<div class="px-3 py-2 text-gray-800">Nenhum resultado encontrado</div>`;
        }
      }
    })
  }
}
